// src/stores/currentTime.ts

import { useEffect, useState } from 'react'

// Hook to get the current time, updating at the specified interval
export const useCurrentTime = (intervalMs: number = 3000) => {
  const [now, setNow] = useState(new Date())

  useEffect(() => {
    const timer = setInterval(() => {
      setNow(new Date())
    }, intervalMs)

    return () => clearInterval(timer)
  }, [intervalMs])

  return now
}
